import { Layout, Page } from '@nimbus-ds/patterns';
import { ErrorScreen, IonPageStratus } from 'commons/components';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

function OrdersAutoCancelPageError({ onRetry }) {
  const t = useTranslationOrders('autoCancel');

  return (
    <IonPageStratus width="small">
      <Page.Header title={t('title')} subtitle={t('description')} />
      <Page.Body>
        <Layout columns="1">
          <Layout.Section>
            <ErrorScreen onRetry={onRetry} link={t('retryOnError')} />
          </Layout.Section>
        </Layout>
      </Page.Body>
    </IonPageStratus>
  );
}

export default OrdersAutoCancelPageError;
